import classes from './drugContent.module.scss';
import { useDrugTabContent } from './useDrugTabContent';
import { Accordion, AccordionTab } from 'primereact/accordion';

const DrugContent = () => {
  const { drugConceptsList, currentTabIndex } = useDrugTabContent();
  const drugDetails = drugConceptsList[currentTabIndex];
  return (
    <div className={classes.drugContentContainer}>
      <div className={classes.header}>{drugDetails.concept}</div>
      <Accordion className={classes.ndcTableAccordion} multiple>
        <AccordionTab className={classes.accordionInstance} header={<div>Concept Details</div>}>
          <div className={classes.tableHolder}>
            <table className={classes.leftSideBar}>
              <tbody>
                <tr>
                  <td className={classes.detailsKey}>
                    {
                      <div style={{ fontWeight: 700 }}>
                        <span>GFC</span>{' '}
                        <span style={{ fontWeight: 400 }}>
                          {' - '}
                          {drugDetails.gfc}
                        </span>
                      </div>
                    }
                  </td>
                  <td>
                    <div className={classes.conceptIdsTableData}>
                      <span>
                        <span style={{ fontSize: '1rem', fontWeight: 700, marginRight: '5px' }}>
                          {`RxCUI `}
                        </span>
                        {` - `}
                        <span style={{ fontSize: '1rem', fontWeight: 400, marginRight: '5px' }}>
                          {drugDetails.generic_rxcui}
                        </span>
                      </span>
                      <span>
                        <span style={{ fontSize: '1rem', fontWeight: 700, marginRight: '5px' }}>
                          {`GTIN `}
                        </span>
                        <span>{` - `}</span>
                        <span style={{ fontSize: '1rem', fontWeight: 400 }}> </span>
                      </span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className={classes.detailsKey}>DES Schedule</td>
                  <td className={classes.conceptIdsTableData}>{drugDetails.des_schedule}</td>
                </tr>
                <tr>
                  <td className={classes.detailsKey}>Duration & Condition</td>
                  <td className={classes.conceptIdsTableData}>{drugDetails.duration_condition}</td>
                </tr>
              </tbody>
            </table>
            <table className={classes.rightSideBar}>
              <tbody>
                <tr>
                  <td className={classes.detailsKey}>Therapeutic Category</td>
                  <td>{drugDetails.therapeutic_category}</td>
                </tr>
                <tr>
                  <td className={classes.detailsKey}>Pharmacologic Class</td>
                  <td>{drugDetails.pharmacologic_class}</td>
                </tr>
                <tr>
                  <td className={classes.detailsKey}>VA Class Name</td>
                  <td>{drugDetails.va_class_name}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </AccordionTab>
      </Accordion>
    </div>
  );
};

export default DrugContent;
